const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

let hasPinged = false;

export const pingServer = async (): Promise<void> => {
  if (hasPinged) return;

  try {
    await fetch(`${API_BASE_URL}/health`);
    hasPinged = true;
  } catch (error) {
    // Silently fail - we don't want to affect the user experience
    console.debug("Failed to ping server:", error);
  }
};
